export const genders = [
  { label: "Hombre", value: "MALE" },
  { label: "Mujer", value: "FEMALE" },
  { label: "Otro", value: "OTHER" },
  { label: "Prefiero no decirlo", value: "NOT_SAY" }
];
